var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { AutoControlledComponent, customPropTypes, childrenExist, commonPropTypes, } from '../../lib';
import AccordionTitle from './AccordionTitle';
import AccordionContent from './AccordionContent';
import { defaultBehavior } from '../../lib/accessibility';
/**
 * An accordion allows users to toggle the display of sections of content.
 * @accessibility
 * Implements ARIA Accordion design pattern (keyboard navigation not yet supported).
 * Consider using Tree if you intend to wrap Lists in an Accordion.
 */
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { activeIndex: [0] };
        _this.computeNewIndex = function (index) {
            var activeIndex = _this.state.activeIndex;
            var exclusive = _this.props.exclusive;
            if (exclusive)
                return index === activeIndex ? -1 : index;
            // check to see if index is in array, and remove it, if not then add it
            return _.includes(activeIndex, index) ? _.without(activeIndex, index) : activeIndex.concat([index]);
        };
        _this.handleTitleOverrides = function (predefinedProps) { return ({
            onClick: function (e, titleProps) {
                var index = titleProps.index;
                var activeIndex = _this.computeNewIndex(index);
                _this.trySetState({ activeIndex: activeIndex }, index);
                _.invoke(predefinedProps, 'onClick', e, titleProps);
                _.invoke(_this.props, 'onTitleClick', e, titleProps);
            },
        }); };
        _this.isIndexActive = function (index) {
            var exclusive = _this.props.exclusive;
            var activeIndex = _this.state.activeIndex;
            return exclusive ? activeIndex === index : _.includes(activeIndex, index);
        };
        _this.renderPanels = function () {
            var children = [];
            var _a = _this.props, panels = _a.panels, renderPanelContent = _a.renderPanelContent, renderPanelTitle = _a.renderPanelTitle;
            _.each(panels, function (panel, index) {
                var content = panel.content, title = panel.title;
                var active = _this.isIndexActive(index);
                children.push(AccordionTitle.create(title, {
                    defaultProps: { active: active, index: index },
                    overrideProps: _this.handleTitleOverrides,
                    render: renderPanelTitle,
                }));
                children.push(AccordionContent.create(content, {
                    defaultProps: { active: active },
                    render: renderPanelContent,
                }));
            });
            return children;
        };
        return _this;
    }
    Accordion.prototype.getInitialAutoControlledState = function (_a) {
        var exclusive = _a.exclusive;
        return { activeIndex: exclusive ? -1 : [-1] };
    };
    Accordion.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, rest = _a.rest;
        var children = this.props.children;
        return (React.createElement(ElementType, __assign({}, accessibility.attributes.root, rest, { className: classes.root }), childrenExist(children) ? children : this.renderPanels()));
    };
    Accordion.displayName = 'Accordion';
    Accordion.className = 'ui-accordion';
    Accordion.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { activeIndex: customPropTypes.every([
            customPropTypes.disallow(['children']),
            PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
        ]), defaultActiveIndex: customPropTypes.every([
            customPropTypes.disallow(['children']),
            PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
        ]), exclusive: PropTypes.bool, onTitleClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]), panels: customPropTypes.every([
            customPropTypes.disallow(['children']),
            PropTypes.arrayOf(PropTypes.shape({
                content: customPropTypes.itemShorthand,
                title: customPropTypes.itemShorthand,
            })),
        ]), accessibility: PropTypes.func, renderPanelTitle: PropTypes.func, renderPanelContent: PropTypes.func });
    Accordion.defaultProps = {
        accessibility: defaultBehavior,
    };
    Accordion.autoControlledProps = ['activeIndex'];
    Accordion.Title = AccordionTitle;
    Accordion.Content = AccordionContent;
    return Accordion;
}(AutoControlledComponent));
export default Accordion;
